export default "__VITE_ASSET__MQH7fvri__"